import { useEffect } from 'react';
import { logToRemote } from '@/utils/remoteLogger';

export const usePerformanceMonitor = () => {
  useEffect(() => {
    // Monitor FPS
    let lastTime = performance.now();
    let frames = 0;
    let rafId: number;
    
    const checkFPS = () => {
      frames++;
      const currentTime = performance.now();
      
      if (currentTime >= lastTime + 1000) {
        const fps = Math.round((frames * 1000) / (currentTime - lastTime));
        
        if (fps < 30) {
          logToRemote('low_fps', { fps }, 'warn');
        }
        
        frames = 0;
        lastTime = currentTime;
      }
      
      rafId = requestAnimationFrame(checkFPS);
    };
    
    rafId = requestAnimationFrame(checkFPS);

    // Monitor Long Tasks (> 50ms)
    let observer: PerformanceObserver | null = null;
    
    if ('PerformanceObserver' in window) {
      try {
        observer = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.duration > 50) {
              logToRemote('long_task', {
                duration: Math.round(entry.duration),
                name: entry.name
              }, 'warn');
            }
          }
        });
        
        observer.observe({ entryTypes: ['longtask'] });
      } catch (error) {
        console.warn('PerformanceObserver no soportado:', error);
      }
    }

    return () => {
      cancelAnimationFrame(rafId);
      observer?.disconnect();
    };
  }, []);
};
